(function () {
  class QuickBuyDrawer extends HTMLElement {
    constructor() {
      super();

      try {
        this.variants = JSON.parse(this.dataset.variants || '[]');
      } catch (e) {
        this.variants = [];
      }
      this.selectedOptions = {};
      this.matchedVariant = null;

      this.panel = this.querySelector('.quick-buy-drawer__panel');
      this.atcBtn = this.querySelector('[data-quick-buy-add]');
      this.priceEl = this.querySelector('[data-quick-buy-price]');
      this.priceCurrentEl = this.querySelector('[data-quick-buy-price-current]');
      this.priceCompareEl = this.querySelector('[data-quick-buy-price-compare]');
      this.optionGroups = this.querySelectorAll('.quick-buy-drawer__option');

      this.optionGroups.forEach((group) => {
        const idx = parseInt(group.dataset.optionIndex, 10);
        const chips = group.querySelectorAll('.quick-buy-drawer__chip');
        chips.forEach((chip) => {
          chip.addEventListener('click', () => this.selectOption(idx, chip));
        });
        this.markUnavailable(idx);
      });

      this.querySelectorAll('[data-quick-buy-close]').forEach((el) => {
        el.addEventListener('click', () => this.close());
      });

      if (this.atcBtn) {
        this.atcBtn.addEventListener('click', () => this.addToCart());
      }

      this.escHandler = (e) => {
        if (e.key === 'Escape' && !this.hasAttribute('hidden')) this.close();
      };

      this.initDefaults();
    }

    isMobileViewport() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    ensurePortalPlaceholder() {
      if (this._portalPlaceholder) return;

      this._portalPlaceholder = document.createComment('quick-buy-drawer');
      this._homeParent = this.parentNode;
      this._homeParent.insertBefore(this._portalPlaceholder, this);
    }

    moveToBody() {
      this.ensurePortalPlaceholder();
      if (this.parentNode !== document.body) {
        document.body.appendChild(this);
      }
    }

    restoreToHome() {
      if (this._portalPlaceholder && this._portalPlaceholder.parentNode) {
        this._portalPlaceholder.parentNode.insertBefore(this, this._portalPlaceholder);
      }
    }

    initDefaults() {
      this.optionGroups.forEach((group, idx) => {
        const chips = group.querySelectorAll('.quick-buy-drawer__chip');
        if (chips.length === 1) {
          const chip = chips[0];
          chip.setAttribute('aria-checked', 'true');
          chip.classList.add('quick-buy-drawer__chip--selected');
          this.selectedOptions[idx] = chip.dataset.optionValue;
          group.hidden = true;
        }
      });

      this.optionGroups.forEach((group, idx) => {
        if (group.hidden) return;
        if (this.selectedOptions[idx] !== undefined) return;

        const labelEl = group.querySelector('.quick-buy-drawer__option-label');
        const label = labelEl ? labelEl.textContent.toLowerCase() : '';
        if (!label.includes('size')) return;

        const chips = Array.from(group.querySelectorAll('.quick-buy-drawer__chip'));
        const firstAvailable = chips.find((chip) => {
          const value = chip.dataset.optionValue;
          return this.variants.some(
            (v) => v.options[idx] === value && v.available
          );
        });
        if (firstAvailable) {
          firstAvailable.setAttribute('aria-checked', 'true');
          firstAvailable.classList.add('quick-buy-drawer__chip--selected');
          this.selectedOptions[idx] = firstAvailable.dataset.optionValue;
        }
      });

      this.updateAvailable();
    }

    open() {
      document.querySelectorAll('quick-buy-drawer:not([hidden])').forEach((drawer) => {
        if (drawer !== this && typeof drawer.close === 'function') drawer.close();
      });

      this._cardWrapper = this.closest('.card-wrapper');
      this._cardWrapper?.classList.add('quick-buy-drawer-host--open');
      this._portaled = this.isMobileViewport();
      if (this._portaled) {
        this.moveToBody();
      }
      this.removeAttribute('hidden');
      if (this._portaled) {
        document.body.style.overflow = 'hidden';
      }
      document.addEventListener('keydown', this.escHandler);
      requestAnimationFrame(() => {
        this.classList.add('quick-buy-drawer--open');
      });
    }

    close() {
      this.classList.remove('quick-buy-drawer--open');
      if (this._portaled) {
        document.body.style.overflow = '';
      }
      document.removeEventListener('keydown', this.escHandler);
      setTimeout(() => {
        this.setAttribute('hidden', '');
        if (this._portaled) {
          this.restoreToHome();
          this._portaled = false;
        }
        this._cardWrapper?.classList.remove('quick-buy-drawer-host--open');
        this._cardWrapper = null;
      }, 280);
    }

    selectOption(optionIndex, chip) {
      const group = chip.closest('.quick-buy-drawer__option');
      group.querySelectorAll('.quick-buy-drawer__chip').forEach((c) => {
        c.setAttribute('aria-checked', 'false');
        c.classList.remove('quick-buy-drawer__chip--selected');
      });
      chip.setAttribute('aria-checked', 'true');
      chip.classList.add('quick-buy-drawer__chip--selected');

      this.selectedOptions[optionIndex] = chip.dataset.optionValue;
      this.updateAvailable();
    }

    markUnavailable(optionIndex) {
      const group = this.optionGroups[optionIndex];
      if (!group) return;
      const chips = group.querySelectorAll('.quick-buy-drawer__chip');
      chips.forEach((chip) => {
        const value = chip.dataset.optionValue;
        const anyAvailable = this.variants.some((v) => {
          if (v.options[optionIndex] !== value) return false;
          if (!v.available) return false;
          for (const [idx, val] of Object.entries(this.selectedOptions)) {
            if (parseInt(idx, 10) === optionIndex) continue;
            if (v.options[parseInt(idx, 10)] !== val) return false;
          }
          return true;
        });
        chip.classList.toggle('quick-buy-drawer__chip--soldout', !anyAvailable);
      });
    }

    updateAvailable() {
      const totalOptions = this.optionGroups.length;
      const selectedCount = Object.keys(this.selectedOptions).length;

      this.optionGroups.forEach((_, idx) => this.markUnavailable(idx));

      if (selectedCount < totalOptions) {
        this.matchedVariant = null;
        this.atcBtn.disabled = true;
        this.atcBtn.textContent = this.atcBtn.dataset.defaultLabel || 'Add to cart';
        return;
      }

      this.matchedVariant = this.variants.find((v) =>
        Object.entries(this.selectedOptions).every(
          ([idx, val]) => v.options[parseInt(idx, 10)] === val
        )
      );

      if (!this.matchedVariant) {
        this.atcBtn.disabled = true;
        this.atcBtn.textContent = 'Unavailable';
        return;
      }

      if (!this.matchedVariant.available) {
        this.atcBtn.disabled = true;
        this.atcBtn.textContent = 'Sold out';
        return;
      }

      this.atcBtn.disabled = false;
      this.atcBtn.textContent = this.atcBtn.dataset.defaultLabel || 'Add to cart';

      if (this.priceCurrentEl && this.matchedVariant.price_formatted) {
        this.priceCurrentEl.textContent = this.matchedVariant.price_formatted;
      }
      if (this.priceCompareEl) {
        const hasCompare =
          this.matchedVariant.compare_at_price &&
          this.matchedVariant.compare_at_price > this.matchedVariant.price;
        if (hasCompare) {
          this.priceCompareEl.textContent = this.matchedVariant.compare_at_price_formatted;
          this.priceCompareEl.removeAttribute('hidden');
          this.priceEl && this.priceEl.classList.add('quick-buy-drawer__price--on-sale');
        } else {
          this.priceCompareEl.setAttribute('hidden', '');
          this.priceEl && this.priceEl.classList.remove('quick-buy-drawer__price--on-sale');
        }
      }
    }

    async addToCart() {
      if (!this.matchedVariant || !this.matchedVariant.available) return;

      const miniCart = document.querySelector('mini-cart');
      const sections = miniCart
        ? miniCart.getSectionsToRender().map((s) => s.id)
        : [];

      this.atcBtn.classList.add('loading');
      this.atcBtn.disabled = true;

      try {
        const res = await fetch(theme.routes.cart_add_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            id: this.matchedVariant.id,
            quantity: 1,
            sections,
            sections_url: window.location.pathname,
          }),
        });
        const data = await res.json();

        if (data.status === 422) {
          document.dispatchEvent(
            new CustomEvent('ajaxProduct:error', {
              detail: { errorMessage: data.description },
            })
          );
          this.atcBtn.textContent = 'Try again';
        } else {
          if (miniCart) miniCart.renderContents(data);
          document.dispatchEvent(
            new CustomEvent('ajaxProduct:added', { detail: { product: data } })
          );
          this.close();
        }
      } catch (e) {
        console.error(e);
        this.atcBtn.textContent = 'Try again';
      } finally {
        this.atcBtn.classList.remove('loading');
        this.atcBtn.disabled = false;
      }
    }
  }
  customElements.define('quick-buy-drawer', QuickBuyDrawer);

  class QuickBuyButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', () => {
        const wrapper = this.closest('.card-wrapper');
        if (!wrapper) return;
        const drawer = wrapper.querySelector('quick-buy-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
      });
    }
  }
  customElements.define('quick-buy-button', QuickBuyButton);
})();
